// your slug‑check function
function handleHashClick() {
  const rawHash = window.location.hash; // e.g. "#section1"
  const slug = rawHash.startsWith("#")
    ? rawHash.slice(1) // "section1"
    : rawHash; // fallback

  // map slugs → selectors
  const mapping = {
    "control-faq_item_3PeBM8": "#control-faq_item_3PeBM8",
    "control-faq_item_9pnqjX": "#control-faq_item_9pnqjX",
    "control-faq_item_inX4Fd": "#control-faq_item_inX4Fd",
    "control-faq_item_AH78VC": "#control-faq_item_AH78VC",
  };

  const selector = mapping[slug];
  if (selector) {
    jQuery(selector).click();
  }
}

// run once on initial page load
jQuery(document).ready(handleHashClick);

// run again whenever the hash changes (e.g. user clicks an <a href="#…"> link)
window.addEventListener("hashchange", handleHashClick);

// ——— optional: also run on *any* click in case something else drives it ———
// jQuery(document).on('click', handleHashClick);

document
  .querySelectorAll(".js-header-dropdown-menu-toggler")
  .forEach((button) => {
    button.addEventListener("click", () => {
      // Find the closest <li> wrapper
      const parentLi = button.closest("li");
      if (!parentLi) return;

      // Find the <a> inside that same <li>
      const anchor = parentLi.querySelector("a.header-menu__item--main.no-js");
      if (anchor) {
        anchor.click(); // trigger the anchor click
      }
    });
  });

/*
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.themeCore.utils.Swiper;
    const mySwiper = new Swiper(".js-slider",{
    speed: 1200,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

    // Select all menu links
    const menuItems = document.querySelectorAll('.header-menu__item');

    // Only attach hover to first 3 menu items
    menuItems.forEach((item, index) => {
      if (index < 3) { // Only first 3 trigger slides
        item.addEventListener('mouseenter', () => {
          mySwiper.slideTo(index); // Slide to 0, 1, 2
        });
      }
    });
  });
*/

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".radio__label[data-url]")
    .forEach(function (label) {
      label.addEventListener("click", function (e) {
        const url = this.getAttribute("data-url");
        if (url) {
          window.location.href = url;
        }
      });
    });
});

/*
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.radio__label[data-product-url]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      const productUrl = el.getAttribute('data-product-url');
    const modalContainer = document.querySelector('.modal.quick-view');
      if (productUrl && modalContainer) {
        // Fetch the quick view HTML from Shopify's ?view=quick-view endpoint
        fetch(productUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newModalContent = doc.querySelector('.modal.quick-view');

            if (newModalContent) {
              modalContainer.innerHTML = newModalContent.innerHTML;

              // Re-open modal (if your theme hides it after update)
              modalContainer.classList.add('is-active');

              // Optionally re-run any JS (e.g. sliders, quantity pickers)
              // reinitializeQuickView(); // ← define this if needed
            }
          });
      }
    });
  });
});
*/

let isQuickViewLoading = false;

document.addEventListener("click", function (e) {
  const el = e.target.closest(".radio__label[data-product-url]");
  if (!el) return;

  // Prevent double clicks or slider interactions causing re-trigger
  if (isQuickViewLoading) return;
  isQuickViewLoading = true;

  e.preventDefault();

  const productUrl = el.getAttribute("data-product-url");
  if (!productUrl) {
    isQuickViewLoading = false;
    return;
  }

  let modalContainer = document.querySelector(".modal.quick-view");

  if (!modalContainer) {
    // Use MutationObserver or wait for modal if dynamically added
    waitForModal(() => {
      const modal = document.querySelector(".modal.quick-view");
      if (modal) {
        loadQuickViewContent(productUrl, modal);
      } else {
        console.error("QuickView modal not found.");
        isQuickViewLoading = false;
      }
    });
  } else {
    loadQuickViewContent(productUrl, modalContainer);
  }
});

/*
function loadQuickViewContent(productUrl, modalContainer) {
  fetch(productUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newModalContent = doc.querySelector('.modal.quick-view');
      if (newModalContent && modalContainer) {
        modalContainer.innerHTML = newModalContent.innerHTML;
        modalContainer.classList.add('is-active');

        // Delay Swiper initialization to make sure content is loaded
        setTimeout(() => {
          initializeSwiper(modalContainer);
        }, 300); // Add a slight delay to ensure Swiper is initialized after DOM is updated

        // Optional: reinitialize modal JS functionality
        // reinitializeQuickView();
      }
    });
}
*/

function waitForModal(callback, maxRetries = 10, delay = 200) {
  let retries = 0;
  const interval = setInterval(() => {
    const modal = document.querySelector(".modal.quick-view");
    if (modal) {
      clearInterval(interval);
      callback(modal);
    } else if (retries >= maxRetries) {
      clearInterval(interval);
      callback(null);
    }
    retries++;
  }, delay);
}

function loadQuickViewContent(productUrl, modalContainer) {
  fetch(productUrl)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newModalContent = doc.querySelector(".modal.quick-view");

      if (newModalContent && modalContainer) {
        modalContainer.innerHTML = newModalContent.innerHTML;
        modalContainer.classList.add("is-active");

        // Re-initialize QuickView
        if (
          window.themeCore.QuickView &&
          typeof window.themeCore.QuickView.init === "function"
        ) {
          try {
            window.themeCore.QuickView.init();
          } catch (err) {
            console.error("QuickView.init error:", err);
          }
        }
      }
      isQuickViewLoading = false;
    })
    .catch((err) => {
      console.error("QuickView load error:", err);
      isQuickViewLoading = false;
    });
}

function handleQuickViewClick(e) {
  const el = e.target.closest(".radio__label[data-product-url]");
  if (!el) return;

  e.preventDefault();
  const productUrl = el.getAttribute("data-product-url");
  if (!productUrl) return;

  // Prevent repeated clicks
  document.removeEventListener("click", handleQuickViewClick);

  let modalContainer = document.querySelector(".modal.quick-view");

  if (!modalContainer) {
    modalContainer = document.querySelector(".modal.quick-view");
    if (modalContainer) {
      loadQuickViewContent(productUrl, modalContainer);
    }
  } else {
    loadQuickViewContent(productUrl, modalContainer);
  }
}
document.addEventListener("click", handleQuickViewClick);

/*
function initializeSwiper(modalContainer) {
  // Check if swiper-container exists in the modal
  const swiperEl = modalContainer.querySelector('.swiper-container');
  if (swiperEl) {
    // Initialize Swiper inside the modal
    new Swiper(swiperEl, {
      speed: 1200,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  } else {
    console.error("Swiper container not found inside modal.");
  }
}
*/

document.addEventListener("click", function (e) {
  const swatchBtn = e.target.closest(".js-product-card-swatch");
  if (!swatchBtn) {
    // console.log('No swatch button clicked');
    return;
  }

  const selectedId = swatchBtn.getAttribute("data-id");
  console.log("Swatch clicked with data-id:", selectedId);

  const swatchWrapper = swatchBtn.closest(".product-card__swatches-wrapper");
  if (!swatchWrapper) {
    console.log("No .product-card__swatches-wrapper found");
    return;
  }

  const productWrapper = swatchWrapper.closest(
    ".product-card__meta-info"
  )?.parentElement;
  if (!productWrapper) {
    console.log("No product wrapper found from .product-card__meta-info");
    return;
  }

  const quickViewBtn = productWrapper.closest(".product-card.js-product-card");
  const quickViewBtntitles = quickViewBtn.querySelectorAll(
    "button.product-card__quick-view-text-button.js-product-card-quick-view-button"
  );
  const imagelnkBtn = quickViewBtn.querySelector(
    ".product-card__image-wrapper-link"
  );

  const productCardLabels = quickViewBtn.querySelectorAll(
    ".product-card__main ul.product-card__labels"
  );

  console.log(quickViewBtntitles);
  console.log("Found product wrapper:", productWrapper);
  console.log("imagelnkBtn:", imagelnkBtn);
  console.log("All labels", productCardLabels);

  // Toggle .product-card__title elements
  const titles = productWrapper.querySelectorAll(".product-card__title");
  console.log("Found title elements:", titles);

  titles.forEach((title) => {
    const titleId = title.getAttribute("data-title");
    const quickViewBtnt = title.getAttribute("data-product-card-handle");

    const show = titleId === selectedId;
    console.log(`Title: ${titleId}, match: ${show}`);
    title.style.setProperty("display", show ? "" : "none", "important");
    if (show) {
      quickViewBtntitles.forEach((quickViewBtntitle) => {
        quickViewBtntitle.setAttribute(
          "data-product-card-handle",
          quickViewBtnt
        );
      });
      imagelnkBtn.setAttribute("href", "/products/" + quickViewBtnt);

      productCardLabels.forEach((productCardLabel) => {
        const curentlabelbtn = productCardLabel.getAttribute("data-labelid");
        if (curentlabelbtn === quickViewBtnt) {
          productCardLabel.style.setProperty("display", "block", "important");
        } else {
          productCardLabel.style.setProperty("display", "none", "important");
        }
      });
    } else {
    }
  });

  // Toggle .product-card__price elements
  const prices = productWrapper.querySelectorAll(".product-card__price");
  console.log("Found price elements:", prices);

  prices.forEach((price) => {
    const priceId = price.getAttribute("data-title");
    const show = priceId === selectedId;
    console.log(`Price: ${priceId}, match: ${show}`);
    price.style.setProperty("display", show ? "" : "none", "important");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all thumbnail buttons
  const thumbnailButtons = document.querySelectorAll(
    ".product-media__slider-thumbnails-slide"
  );
  // Get the video element
  const videoElement = document.querySelector(".product-gallery-video__html");

  if (videoElement) {
    // Add loop attribute to video
    videoElement.loop = true;
  }

  thumbnailButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Check if this is the video thumbnail (last thumbnail)
      const isVideoThumb =
        this.classList.contains("swiper-slide-thumb-active") &&
        this.querySelector(".product-media__thumbnail-poster");

      if (isVideoThumb && videoElement) {
        videoElement.play();
      } else if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
      }
    });
  });

  // Optional: Handle video behavior when using swiper navigation
  const swiperButtons = document.querySelectorAll(
    ".product-media__navigation-button"
  );
  swiperButtons.forEach((button) => {
    button.addEventListener("click", function () {
      if (videoElement) {
        const isVideoSlideActive = document.querySelector(
          ".swiper-slide-active[data-zoom-media-html-video]"
        );
        if (isVideoSlideActive) {
          videoElement.play();
        } else {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const videoElement = document.querySelector('.product-gallery-video__html');
    const prevButton = document.querySelector('.js-product-media-slider-prev-template--18432268632233__product-template');
    const nextButton = document.querySelector('.js-product-media-slider-next-template--18432268632233__product-template');
    
    // Set video attributes
    if (videoElement) {
        videoElement.loop = true;
        videoElement.muted = true;
        videoElement.playsinline = true;
    }

    // Handle navigation buttons
    [prevButton, nextButton].forEach(button => {
      if (button) {
        button.addEventListener('click', function() {
            setTimeout(() => {
                const activeSlide = document.querySelector('.swiper-slide-active');
                if (activeSlide && activeSlide.getAttribute('data-zoom-media-html-video')) {
                    videoElement.play();
                } else if (videoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                }
            }, 100);
        });
      }
    });
});
